import React from 'react';
import { CountdownTimer } from './CountdownTimer';

const BiddingPanelInline = ({ auction, bidAmount, setBidAmount, minBid, incrementBid, decrementBid, bidding, error, setError, setShowConfirm, user, showAutobid, setShowAutobid, autobidActive, autobidMax, setAutobidMax, handleAutobid, cancelAutobid, fetchAuction }) => {
  return (
    <div className="bg-gray-50 rounded-xl p-4" data-testid="mobile-bid-panel">
      {/* Status Badge */}
      <div className="text-center mb-3">
        <span className={`inline-block ${auction.status === 'active' ? 'badge-live pulse-live' : auction.status === 'ended' ? 'badge-ended' : 'badge-scheduled'}`}>
          {auction.status === 'active' ? 'LIVE' : auction.status === 'ended' ? 'TERMINATA' : 'PROSSIMA'}
        </span>
      </div>

      {/* Timer */}
      {auction.status === 'active' && (
        <div className="text-center mb-2">
          <CountdownTimer endTime={auction.end_time} onEnd={fetchAuction} />
        </div>
      )}

      {/* Price */}
      <p className="text-3xl font-bold text-center text-[#0a1628] mb-1">{'\u20AC'}{auction.current_price?.toLocaleString()}</p>
      <p className="text-xs text-[#64748b] text-center mb-3">{auction.total_bids} offerte</p>

      {/* Ended */}
      {auction.status === 'ended' && (
        <div className="text-center mb-3">
          <p className="text-red-600 font-bold text-sm">ASTA TERMINATA</p>
          <p className="text-red-500 text-xs">Non è più possibile fare offerte.</p>
        </div>
      )}

      {/* Bid Controls */}
      {auction.status === 'active' && (
        <>
          <div className="flex items-center justify-center gap-3 mb-3">
            <button onClick={decrementBid} disabled={bidAmount <= minBid} className="w-10 h-10 rounded-full border-2 border-gray-300 text-lg font-bold text-gray-600 hover:border-[#c9a227] transition-colors disabled:opacity-30">-</button>
            <div className="text-center px-3">
              <p className="text-xl font-bold">{'\u20AC'}{bidAmount.toLocaleString()}</p>
              <p className="text-[10px] text-[#64748b]">La tua offerta</p>
            </div>
            <button onClick={incrementBid} className="w-10 h-10 rounded-full border-2 border-gray-300 text-lg font-bold text-gray-600 hover:border-[#c9a227] transition-colors">+</button>
          </div>
          <button
            onClick={() => {
              if (!user) { window.location.href = '/login'; return; }
              if (!user.is_verified) { setError('Account non verificato. Invia documenti a info@equusprime.it'); return; }
              setShowConfirm(true);
            }}
            disabled={bidding || bidAmount < minBid}
            className="w-full bg-[#0a7e8c] text-white py-3 rounded-lg font-bold text-base hover:bg-[#086a76] transition-colors disabled:opacity-50"
          >
            {bidding ? 'Invio...' : `Fai offerta a \u20AC${bidAmount.toLocaleString()}`}
          </button>
          {/* Autobid */}
          {autobidActive ? (
            <div className="mt-2 bg-green-50 border border-green-200 rounded-lg p-2 flex items-center justify-between">
              <div><p className="text-green-700 text-xs font-medium">Autobid attivo fino a {'\u20AC'}{autobidActive.max_amount?.toLocaleString()}</p></div>
              <button onClick={cancelAutobid} className="text-red-500 text-xs font-medium hover:underline">Disattiva</button>
            </div>
          ) : (
            <div className="mt-2">
              {!showAutobid ? (
                <button onClick={() => setShowAutobid(true)} className="w-full text-xs text-[#0a7e8c] font-medium py-1.5 border border-dashed border-[#0a7e8c] rounded-lg hover:bg-[#0a7e8c]/5 transition-colors">
                  Attiva Autobid
                </button>
              ) : (
                <div className="bg-white border border-gray-200 rounded-lg p-2">
                  <div className="flex gap-2">
                    <input type="number" value={autobidMax} onChange={e => setAutobidMax(e.target.value)} placeholder="Max (€)" className="input-field flex-1 text-xs" min={minBid} step="100" />
                    <button onClick={handleAutobid} className="px-3 py-1.5 bg-[#0a7e8c] text-white rounded text-xs font-medium">Attiva</button>
                    <button onClick={() => setShowAutobid(false)} className="text-gray-400 text-xs">X</button>
                  </div>
                </div>
              )}
            </div>
          )}
          {error && <p className="text-red-500 text-xs mt-2 text-center">{error}</p>}
          {!user && <p className="text-xs text-[#64748b] mt-2 text-center"><a href="/login" className="text-[#c9a227]">Accedi</a> per fare un'offerta</p>}
        </>
      )}
    </div>
  );
};

export default BiddingPanelInline;
